import React from 'react';

import axios from 'axios';
import { Modal } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { REQUEST_URL } from '../config/urls';

class ModalLoginPersonalizadas extends React.Component {
  
  state = {
    data: [],
    carregando: false
  }

  componentDidMount () {
    if (this.props.contrato) {
      this.setState({ carregando: true });
      axios.get(`${REQUEST_URL}/personalizadas/logins/${this.props.contrato.numero}`).then((response) => {
        this.setState({ data: response.data, carregando: false });
      }).catch((err) => {
        console.log(err);
        this.setState({ carregando: false });
      });
    }
  }

  baixarTabela () {
    let janela = window.open('', 'Impressão');

    janela.document.write('<html><head><title>Senhas de acesso - Sistema de preenchimento das personalizadas da Alpha Convites</title><link id="link" rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous"></head><body>');
    janela.document.write('<h3>Senhas de acesso para o preenchimento das páginas personalizadas</h3>');
    janela.document.write(document.querySelector(`#tabelaLogins`).innerHTML);
    janela.document.write('</body></html>');
    janela.print();
  }

  _renderTabelaLogins () {
    return (
      <React.Fragment>
        <button className="btn btn-link btnSemFundo" type="button" onClick={this.baixarTabela.bind(this)}><i className="fa fa-download"></i> Baixar tabela</button>
        <div className="table-responsive" id="tabelaLogins">
          <table className="table">
            <thead>
              <tr>
                <th>Formando</th>
                <th>Login</th>
                <th>Senha</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.data.map((formando, i) => (
                  <tr key={i}>
                    <td><img src={`https://personalizada.alphaconvites.com.br/${formando.foto_principal}`} alt="Foto do formando" width="150px"/></td>
                    <td>{formando.usuario}</td>
                    <td>{formando.senha}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }

  render () {
    return (   
      <React.Fragment>
        <Modal.Header closeButton>Login do sistema de preenchimento das personalizadas do contrato {this.props.contrato.numero}</Modal.Header>
        <Modal.Body>
          {
            this.state.carregando ?
              <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><i className="fa fa-spin fa-spinner"></i> Carregando</div>
            : !this.state.carregando ?
              this.state.data.length > 0 ?
                this._renderTabelaLogins()
              : <div>Os logins deste contrato ainda não foram gerados!</div>
            : null
          }
        </Modal.Body>
      </React.Fragment>
    )
  }
}

export default ModalLoginPersonalizadas;


// WEBPACK FOOTER //
// ./src/components/ModalLoginPersonalizadas.js